import React, {useContext} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';

// pages
import Authenticated from '../Pages/Authenticated';
import Blocked from "../Pages/Blocked";

// components
import Header from '../Header';
import Footer from "../Footer";
import Loading from "../Loading";

// Import CSS reset and Global Styles
import GlobalStyle from '../../global-styles';

import AppContext from "../../contexts/App/App.context";
import {accessStatus} from "../../shared/enums";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

import {unauthenticated, unauthorized} from "./utils"

const App = () => {
    const {access} = useContext(AppContext);

    const blockedContent = {
        [accessStatus.NONE]: <Loading />,
        [accessStatus.AUTHENTICATED_ONLY]: unauthorized(),
        [accessStatus.UNAUTHENTICATED]: unauthenticated()
    };

    return (
        <>
            <Router basename='/priorauth'>
                <Header authenticated={access}/>
                <div id="MEDCAL_RX_CONTENT_CONTAINER">
                    <ErrorBoundary>
                        {access === accessStatus.AUTHORIZED && <Authenticated/>}
                        {blockedContent[access] && <Blocked content={blockedContent[access]}/>}
                    </ErrorBoundary>
                </div>
                <Footer/>
                <GlobalStyle />
            </Router>
        </>
    );
}

export default App;
